import styles from './EditPanelDescription.module.scss';

interface DescriptionProps {
  children: string;
}

export function EditPanelDescription(props: DescriptionProps) {
  return <p className={styles.description}>{props.children}</p>;
}
